import Badge, { type BadgeProps } from "@common/controls/Badge/component";

import "./style.less";

export { type BadgeProps };

export default Badge;
